import React from 'react'
import styles from './FluIndices.module.scss'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import GeoProvider from '../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from './dataDisplayOptions'
import { startDate, endDate, displayDate } from './dates'
import Header from './Header'
import MiddleCharts from './MiddleChart'
import GenderAgeView from './Charts/GenderAgeView'
import { useLocation } from "react-router-dom";
import diseaseDisplayOptions from './diseaseDisplayOptions'
const AllergiesDashboard = () => {
  if(window.localStorage.getItem('disease')===null)
    {window.localStorage.setItem('disease',diseaseDisplayOptions[0].value)}
  var getRegionType = 'zip3'
  const location = useLocation()
  const hash = location.hash
  if (hash) {
    if (hash.length > 1 && hash === '#zip3') {
      getRegionType = 'zip3'
    }
  }

  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              locationName={"NAT"}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={getRegionType}
            >
              <Header headerType="NAT" headerNumber={1}  geo_id="NAT"/>
              <DashboardMap 
                geo_type={'NAT'}
                geo_parent={'NAT'}
                zoomLocation={'NAT'} />
              <MiddleCharts geo_type="NAT" geo_id="NAT" data_type="ALLERGIES" />
              <GenderAgeView 
                data_type="ALLERGIES" 
                geo_type={'NAT'}
                geo_id={'NAT'}  
                searchLocation={'NAT'} 
                searchLocationText={'NAT'}/>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default AllergiesDashboard
